import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-reports-menu',
  templateUrl: './payroll-reports-menu.component.html',
  styleUrls: ['./payroll-reports-menu.component.css']
})
export class PayrollReportsMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/payroll-reports/payroll-reports-menu/payroll-reports-menu.component.ts